module.exports = __webpack_public_path__ + "static/media/about_hero.3ed0d423.jpg";